import API from "../../../api.js";
import {
  ADMIN_MED_LIST_REQUEST,
  ADMIN_MED_LIST_SUCCESS,
  ADMIN_MED_LIST_FAIL,
  ADMIN_MED_CREATE_REQUEST,
  ADMIN_MED_CREATE_SUCCESS,
  ADMIN_MED_CREATE_FAIL,
  ADMIN_MED_UPDATE_REQUEST,
  ADMIN_MED_UPDATE_SUCCESS,
  ADMIN_MED_UPDATE_FAIL,
  ADMIN_MED_DELETE_REQUEST,
  ADMIN_MED_DELETE_SUCCESS,
  ADMIN_MED_DELETE_FAIL,
  ADMIN_MED_ADD_STOCK_REQUEST,
  ADMIN_MED_ADD_STOCK_SUCCESS,
  ADMIN_MED_ADD_STOCK_FAIL,
  ADMIN_MED_REPORT_REQUEST,
  ADMIN_MED_REPORT_SUCCESS,
  ADMIN_MED_REPORT_FAIL,
  ADMIN_MED_TOP_REQUEST,
  ADMIN_MED_TOP_SUCCESS,
  ADMIN_MED_TOP_FAIL,
  ADMIN_MED_SELL_REQUEST,
  ADMIN_MED_SELL_SUCCESS,
  ADMIN_MED_SELL_FAIL,
} from "../../constants/adminConstants/adminMedicineConstants.js";

// LIST
export const listMedicines = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_MED_LIST_REQUEST });
    const { data } = await API.get("/admin/medicine");

    dispatch({ type: ADMIN_MED_LIST_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ADMIN_MED_LIST_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
  }
};

// CREATE
export const createMedicine = (formData) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_MED_CREATE_REQUEST });
    const { data } = await API.post("/admin/medicine", formData);
    dispatch({ type: ADMIN_MED_CREATE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ADMIN_MED_CREATE_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
  }
};

// UPDATE
export const updateMedicine = (id, formData) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_MED_UPDATE_REQUEST });
    const { data } = await API.put(`/admin/medicine/${id}`, formData);
    dispatch({ type: ADMIN_MED_UPDATE_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ADMIN_MED_UPDATE_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
  }
};

// // DELETE
// export const deleteMedicine = (id) => async (dispatch) => {
//   try {
//     dispatch({ type: ADMIN_MED_DELETE_REQUEST });
//     await API.delete(`/admin/medicine/${id}`);
//     dispatch({ type: ADMIN_MED_DELETE_SUCCESS, payload: id });
//   } catch (err) {
//     dispatch({
//       type: ADMIN_MED_DELETE_FAIL,
//       payload: err.response?.data?.msg || err.message,
//     });
//   }
// };

// ADD STOCK
export const addStock = (id, qty) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_MED_ADD_STOCK_REQUEST });
    const { data } = await API.post(`/admin/medicine/${id}/stock`, { qty });
    dispatch({ type: ADMIN_MED_ADD_STOCK_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ADMIN_MED_ADD_STOCK_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
  }
};

// SELL
export const sellMedicine = (item) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_MED_SELL_REQUEST });
    const { data } = await API.post(`/admin/medicine/sell`, item);
    dispatch({ type: ADMIN_MED_SELL_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ADMIN_MED_SELL_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
  }
};

// REPORT
// export const fetchSalesReport = () => async (dispatch) => {
//   try {
//     dispatch({ type: ADMIN_MED_REPORT_REQUEST });
//     const { data } = await API.get("/admin/medicine/report");
//     dispatch({ type: ADMIN_MED_REPORT_SUCCESS, payload: data });
//   } catch (err) {
//     dispatch({
//       type: ADMIN_MED_REPORT_FAIL,
//       payload: err.response?.data?.msg || err.message,
//     });
//   }
// };

// TOP SELLING
export const fetchTopSelling = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_MED_TOP_REQUEST });
    const { data } = await API.get("/admin/medicine/top-selling");
    dispatch({ type: ADMIN_MED_TOP_SUCCESS, payload: data });
  } catch (err) {
    dispatch({
      type: ADMIN_MED_TOP_FAIL,
      payload: err.response?.data?.msg || err.message,
    });
  }
};
